import { render, staticRenderFns } from "./OrderNumbers.vue?vue&type=template&id=5707a83c&"
import script from "./OrderNumbers.vue?vue&type=script&lang=js&"
export * from "./OrderNumbers.vue?vue&type=script&lang=js&"
import style0 from "./OrderNumbers.vue?vue&type=style&index=0&id=5707a83c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports